import { css } from '@emotion/core';
import { media, tokens, shadow } from '@domain-group/fe-brary';
export var cardRow = {
  name: "79elbk",
  styles: "position:relative;"
};
export var items = {
  name: "kajr2y",
  styles: "display:flex;overflow-x:auto;overflow-y:hidden;-ms-overflow-style:none;scrollbar-width:none;gap:16px;::-webkit-scrollbar{display:none;}"
};
export var card = /*#__PURE__*/css("width:320px;min-width:320px;", media('>=tablet'), "{width:100%;}");
var scrollBtn = /*#__PURE__*/css("position:absolute;top:50%;transform:translateY(-50%);background:none;border:0;outline:0;width:40px;height:40px;background-color:", tokens.colors.neutral.surface.default, ";box-shadow:", shadow(tokens.shadows.elevation4), ";border-radius:50%;z-index:2;transition:opacity 0.3s;");
export var scrollBtnLeft = /*#__PURE__*/css(scrollBtn, " left:10px;");
export var scrollBtnRight = /*#__PURE__*/css(scrollBtn, " right:10px;");
export var scrollButtonIcon = /*#__PURE__*/css("display:flex;color:", tokens.colors.neutral.medium.default, ";padding:0;width:30px;height:16px;cursor:pointer;", media('>=desktop'), "{&:hover{color:", tokens.colors.interactive.base.default, ";}}");